import React, { memo, useCallback, useRef } from 'react'

import { isApp } from '@zet/utils'

import { Backdrop } from './backdrop'
import { IconList } from './icon/list'
import type { ShareData, WebShareProps } from './interfaces'
import { Portal } from './portal'
import { SocialIcons } from './socialIcons'
import './style.css'
import { useDisclosure } from './use-disclosure'

const defaultSites = Object.keys(IconList).slice(0, 8)

export const useWebShare = (props?: WebShareProps) => {
  const shareDataRef = useRef<Required<ShareData>>({
    title: 'share',
    text: '',
    url: '',
    number: '',
  })

  const { isOpen, onClose, onOpen } = useDisclosure()

  const openWebShare = useCallback(
    async (shareData: Required<ShareData>) => {
      shareDataRef.current = shareData
      // if (window.navigator.share) {
      //   try {
      //     await window.navigator.share(shareData)
      //   } catch (e) {
      //     console.warn(e)
      //   }
      // } else {
      onOpen()
      // }
    },
    [onOpen],
  )

  const WebShare = memo(() => {
    if (isApp) {
      return <></>
    }
    return (
      <>
        {/* Share Component */}
        {isOpen && shareDataRef?.current && (
          <Portal>
            <Backdrop onClose={onClose}>
              <SocialIcons
                onClose={onClose}
                sites={props?.sites || defaultSites}
                data={shareDataRef?.current}
                closeText={props?.closeText}
                onClick={props?.onClick}
              />
            </Backdrop>
          </Portal>
        )}
      </>
    )
  })

  return { openWebShare, WebShare }
}
